import React from "react";
import { Input } from "./input";
import { CharacterCount } from "./character-count";
import { cn } from "@/lib/utils";

interface InputWithCountProps extends React.ComponentProps<"input"> {
  value?: string;
  min?: number | string;
  max: number | string;
  showRemaining?: boolean;
  label?: string;
  helperText?: string;
  error?: string;
}

export const InputWithCount = React.forwardRef<
  HTMLInputElement,
  InputWithCountProps
>(({
  value = "",
  min,
  max,
  showRemaining = false,
  label,
  helperText,
  error,
  className,
  id,
  ...props
}, ref) => {
  const currentLength = value.length;
  const countId = `${id}-count`;

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={id} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          {label}
        </label>
      )}
      
      <div className="space-y-1">
        <Input
          ref={ref}
          id={id}
          value={value}
          className={cn(
            error && "border-destructive focus-visible:ring-destructive",
            className
          )}
          aria-describedby={cn(
            helperText && `${id}-helper`,
            `${countId}`
          )}
          {...props}
        />
        
        <div className="flex items-center justify-between">
          <div className="flex-1">
            {helperText && !error && (
              <p id={`${id}-helper`} className="text-xs text-muted-foreground">
                {helperText}
              </p>
            )}
            {error && (
              <p className="text-xs text-destructive">{error}</p>
            )}
          </div>
          
          <CharacterCount
            id={countId}
            current={currentLength}
            min={min}
            max={max}
            showRemaining={showRemaining}
          />
        </div>
      </div>
    </div>
  );
});

InputWithCount.displayName = "InputWithCount";